"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _reactStickynode = _interopRequireDefault(require("react-stickynode"));

var _hooks = require("@alycecom/hooks");

var _Layout2Columns = _interopRequireDefault(require("../Layout2Columns/Layout2Columns"));

var styles = {
  navBar: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 2,
    background: function background(_ref) {
      var palette = _ref.palette;
      return palette.common.white;
    },
    position: 'relative',
    '& .sticky-inner-wrapper': {
      zIndex: function zIndex(_ref2) {
        var _zIndex = _ref2.zIndex;
        return _zIndex.appBar;
      }
    }
  },
  navToolbar: {
    padding: function padding(_ref3) {
      var spacing = _ref3.spacing;
      return spacing(4, 7);
    }
  },
  navToolbarTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    color: function color(_ref4) {
      var palette = _ref4.palette;
      return palette.text.primary;
    },
    fontSize: '1.5rem',
    lineHeight: '2rem',
    fontWeight: 700
  },
  subtitle: {
    color: function color(_ref5) {
      var palette = _ref5.palette;
      return palette.grey.main;
    }
  },
  navTabs: {
    width: '100%',
    minHeight: 'auto',
    '& [role="tab"]': {
      height: 'auto',
      minHeight: 'auto',
      minWidth: 'auto',
      padding: function padding(_ref6) {
        var spacing = _ref6.spacing;
        return spacing(2, 5);
      }
    }
  },
  navTabsContainerSticky: {
    boxShadow: 2,
    background: function background(_ref7) {
      var palette = _ref7.palette;
      return palette.common.white;
    }
  },
  tabsLayout: {
    paddingLeft: function paddingLeft(_ref8) {
      var spacing = _ref8.spacing;
      return spacing(2);
    },
    paddingRight: function paddingRight(_ref9) {
      var spacing = _ref9.spacing;
      return spacing(2);
    },
    alignItems: 'center'
  }
};

var EditHeader = function EditHeader(_ref10) {
  var title = _ref10.title,
      subtitle = _ref10.subtitle,
      toolbar = _ref10.toolbar,
      navBar = _ref10.navBar,
      _ref10$tabs = _ref10.tabs,
      tabs = _ref10$tabs === void 0 ? [] : _ref10$tabs,
      _ref10$TabsProps = _ref10.TabsProps,
      tabsProps = _ref10$TabsProps === void 0 ? {} : _ref10$TabsProps,
      _ref10$sticky = _ref10.sticky,
      sticky = _ref10$sticky === void 0 ? false : _ref10$sticky,
      stickyContainerId = _ref10.stickyContainerId;
  var _tabsProps$sx = tabsProps.sx,
      tabsSx = _tabsProps$sx === void 0 ? [] : _tabsProps$sx,
      onChange = tabsProps.onChange,
      value = tabsProps.value,
      restTabsProps = (0, _objectWithoutProperties2.default)(tabsProps, ["sx", "onChange", "value"]);
  (0, _hooks.useWindowScrollToEffect)('top', [value]);

  var renderNavBar = function renderNavBar(isSticky) {
    return /*#__PURE__*/_react.default.createElement(_Layout2Columns.default, {
      indented: false,
      sx: styles.tabsLayout,
      leftSection: /*#__PURE__*/_react.default.createElement(_material.Fade, {
        in: isSticky,
        mountOnEnter: true,
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement(_material.Box, {
        display: "flex",
        alignItems: "center"
      }, toolbar === null || toolbar === void 0 ? void 0 : toolbar.left))
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      flexDirection: "row"
    }, /*#__PURE__*/_react.default.createElement(_material.Tabs, (0, _extends2.default)({}, restTabsProps, {
      value: value,
      onChange: onChange,
      sx: [styles.navTabs].concat((0, _toConsumableArray2.default)(Array.isArray(tabsSx) ? tabsSx : [tabsSx]))
    }), tabs), /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      flex: "0 0 auto"
    }, navBar === null || navBar === void 0 ? void 0 : navBar.right)));
  };

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.navBar
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    sx: styles.navToolbar,
    container: true,
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, toolbar === null || toolbar === void 0 ? void 0 : toolbar.left), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4,
    sx: styles.navToolbarTitle
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.title
  }, title), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.subtitle
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 4
  }, toolbar === null || toolbar === void 0 ? void 0 : toolbar.right)), sticky ? /*#__PURE__*/_react.default.createElement(_reactStickynode.default, null, function (_ref11) {
    var status = _ref11.status;
    var isSticky = status === _reactStickynode.default.STATUS_FIXED;
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      id: stickyContainerId,
      sx: [isSticky && styles.navTabsContainerSticky]
    }, renderNavBar(isSticky));
  }) : renderNavBar(false));
};

var _default = EditHeader;
exports.default = _default;